import React from 'react';
import loadable from '@loadable/component';
import { PointOfInterest } from '@components/SectionBlocks/blocks/Charts/RouteCharts';
import { ElevationChart } from '@components/SectionBlocks/blocks/Charts/ElevationChart';
import { useElPrixRouteData } from '@hooks/useElPrixRouteData';
import * as S from './AltitudeChartSerializer.styles';

const GoogleMapsWrapper = loadable(() => import('@components/SectionBlocks/blocks/Charts/GoogleMapsWrapper'), {
  resolveComponent: (m) => m.GoogleMapsWrapper,
});

type Props = {
  value: {
    _key: string;
    _type: 'altitudeChart';
  } & (CustomRouteAltitudeData | TestRouteAltitudeData);
};

type TestRouteAltitudeData = {
  useRouteFromTest: true;
  elPrixTestReference: { routepoints: PointOfInterest[]; altitudeProfile: number[] };
};
type CustomRouteAltitudeData = { useRouteFromTest: false; routepoints: PointOfInterest[]; altitudeProfile: number[] };

const AltitudeChartSerializer =
  () =>
  ({ value }: Props) => (
    <GoogleMapsWrapper>
      <RenderAltitudeChart value={value} />
    </GoogleMapsWrapper>
  );

const RenderAltitudeChart = ({ value }: Props) => {
  const { routepoints, altitudeProfile } = value.useRouteFromTest === true ? value.elPrixTestReference : value;
  const { pointsOfInterest } = useElPrixRouteData({ routepoints, elevation: altitudeProfile });

  return (
    <S.ChartContainer>
      <ElevationChart altitudes={altitudeProfile} pointsOfInterest={pointsOfInterest} />
    </S.ChartContainer>
  );
};

export { AltitudeChartSerializer };
